const HeatMap = () => {
    return (
        <div>
            <coingecko-coin-heatmap-widget
            height="600"
            locale="en"
            ></coingecko-coin-heatmap-widget>
        </div>
    )
}


export default HeatMap